import {
  getStations,
  getUnits,
  createUnit,
  updateUnit,
  deleteUnit,
  getAllUnits,
  updateUnitDirect,
  getStationsStatesEnum,
  getUnitTypesEnum,
} from '../../functions/stationsAndUnitsApi';
import { createThunkAction } from '../../utils/createThunkAction';
import {
  isStationsLoading,
  setStations,
  isAllUnitsLoading,
  setAllUnits,
  isStationUnitsLoading,
  setStationUnits,
  setStationsStates,
  isStationsStatesLoading,
  setUnitsTypes,
  isUnitsTypesLoading,
} from './slice';
import { toast } from 'react-toastify';

export const stationsAndUnitsThunk = {
  getStations: createThunkAction(getStations, setStations, isStationsLoading),

  getUnits: (params, stationId) => async (dispatch) => {
    try {
      dispatch(isStationUnitsLoading(true));
      const response = await getUnits(params, stationId);
      if (response.status === 200) {
        dispatch(setStationUnits(response.data?.data ?? response.data));
      } else {
        throw response;
      }
    } catch (err) {
      toast.error('Failed to load station units');
      console.error(err);
    } finally {
      dispatch(isStationUnitsLoading(false));
    }
  },

  createUnit: (formData, stationId) => async (dispatch) => {
    try {
      dispatch(isStationUnitsLoading(true));
      await createUnit(formData, stationId);
      toast.success('Unit created successfully');
    } catch (err) {
      toast.error('Failed to create unit');
      console.error(err);
    } finally {
      dispatch(isStationUnitsLoading(false));
    }
  },

  updateUnit: (formData, stationId, unitId) => async (dispatch) => {
    try {
      dispatch(isStationUnitsLoading(true));
      await updateUnit(formData, stationId, unitId);
      toast.success('Unit updated successfully');
    } catch (err) {
      toast.error('Failed to update unit');
      console.error(err);
    } finally {
      dispatch(isStationUnitsLoading(false));
    }
  },

  updateUnitDirect: (formData, unitId) => async (dispatch) => {
    try {
      dispatch(isAllUnitsLoading(true));
      await updateUnitDirect(formData, unitId);
      toast.success('Unit updated successfully');
    } catch (err) {
      toast.error('Failed to update unit');
      console.error(err);
    } finally {
      dispatch(isAllUnitsLoading(false));
    }
  },

  deleteUnit: (stationId, unitId) => async (dispatch) => {
    try {
      dispatch(isStationUnitsLoading(true));
      await deleteUnit(stationId, unitId);
      toast.success('Unit deleted successfully');
    } catch (err) {
      toast.error('Failed to delete unit');
      console.error(err);
    } finally {
      dispatch(isStationUnitsLoading(false));
    }
  },

  getAllUnitsThunk: createThunkAction(getAllUnits, setAllUnits, isAllUnitsLoading),
  
  getStationsStatesThunk: createThunkAction(
    getStationsStatesEnum,
    setStationsStates,
    isStationsStatesLoading
  ),
  getUnitsTypesThunk: createThunkAction(
    getUnitTypesEnum,
    setUnitsTypes,
    isUnitsTypesLoading
  ),
};
